module.exports = __webpack_public_path__ + "img/PR2.4291f0a4.gif";